module.exports = __webpack_public_path__ + "img/award-logo.da780852.png";